import type { RagAssistantMessage, RagMessage } from "../types/ragChatTypes";

let idSeq = 0;
export function ragId(prefix: string) {
  return `${prefix}-${++idSeq}`;
}

const DEMO_TABLE = `| Torque (Nm) | Sequence |
|-------------|----------|
| 45 ± 5      | A → B    |
| 90 ± 10     | Final    |`;

export function createWelcomeAssistant(): RagAssistantMessage {
  return {
    id: ragId("assistant"),
    role: "assistant",
    answer:
      "Ask about procedures, diagnostics, part locations, or product information. Answers can include steps, diagrams, tables, and source manuals.",
    images: [],
    videos: [],
    sources: [],
    options: [],
    inlineImages: {},
    pageTables: {},
    pageAlerts: {},
    relatedQuestions: [],
    alternativePdfs: [],
    responseType: "answer",
    queryType: null,
    primarySource: null,
    alternativeSources: [],
    aiEnhancement: null,
  };
}

/** Rich assistant message showcasing tables, alerts, options, follow-ups, sources (UI demo). */
export function createDemoAssistantReply(): RagAssistantMessage {
  return {
    id: ragId("assistant"),
    role: "assistant",
    answer: `Follow these steps to complete the inspection. [p.12]

1. Park the vehicle on level ground and apply the parking brake.
2. Locate the service port under the hood [p.14].
3. Measure clearance with a feeler gauge; record values in the table below.

If pressure drops below minimum, choose the next action.`,
    images: [
      { path: "diagram-clearance.png", metadata: { page: "14" } },
      { path: "diagram-overview.png", metadata: { page: "15" } },
    ],
    videos: [{ path: "brake-bleed-overview.mp4", name: "brake-bleed-overview.mp4" }],
    sources: [
      { pdf_name: "Service_Manual_2024.pdf" },
      { pdf_name: "Service_Manual_2024.pdf" },
      { pdf_name: "Quick_Reference.pdf" },
    ],
    options: ["Re-bleed the circuit", "Replace master cylinder", "Continue to next test"],
    inlineImages: {
      "14": [{ path: "diagram-clearance.png" }],
    },
    pageTables: {
      "12": [DEMO_TABLE],
    },
    pageAlerts: {
      "14": [
        { level: "warning", text: "Hot surfaces — allow the engine to cool before opening the cap." },
        { level: "note", text: "Use only the specified fluid grade." },
      ],
    },
    relatedQuestions: [
      "What torque applies to the caliper bracket bolts?",
      "How do I bleed ABS on this model?",
    ],
    alternativePdfs: ["Owners_Handbook.pdf", "Wiring_Diagrams.pdf"],
    responseType: "answer",
    queryType: "instructions",
    primarySource: null,
    alternativeSources: [],
    aiEnhancement: null,
  };
}

export function getInitialMessages(): RagMessage[] {
  return [createWelcomeAssistant()];
}
